import { cn } from '@/lib/utils';

export function AbsenceNoteStack({
  notes,
  className,
}: {
  notes: { id: string; title: string; body: string | null }[];
  className?: string;
}) {
  if (notes.length === 0) {
    return null;
  }
  return (
    <div
      role="status"
      data-testid="absence-note-stack"
      className={cn('max-h-36 overflow-y-auto', className)}
    >
      <ul className="space-y-2">
        {notes.map((note) => (
          <li
            key={note.id}
            className="rounded-lg border border-amber-300 bg-amber-50 px-3 py-2 text-sm text-amber-950 dark:border-amber-800 dark:bg-amber-950/40 dark:text-amber-100"
          >
            <p className="font-medium">{note.title}</p>
            {note.body ? <p className="mt-1 break-words whitespace-pre-wrap">{note.body}</p> : null}
          </li>
        ))}
      </ul>
    </div>
  );
}
